import { useEffect } from 'react';
import { useParams } from "react-router-dom";
import AdminSideBar from "../../components/adminSideBar/AdminSideBar"
import { useContext } from "react";
import { EnvoieContext } from "../../context/envoieContext/EnvoieContext";
import { getHistories } from '../../context/envoieContext/apiCalls';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import './trackingEnvoie.css';
import { communes, currentStatusEnvois, historyCases, statusEnvois, wilayas } from '../../data';

function TrackingEnvoie() {
    const { id } = useParams();
    const { dispatch, histories, isFetchingHistories, errorHistories, } = useContext(EnvoieContext);

    useEffect(() => {
        getHistories(dispatch, id);
    }, [id])

    useEffect(() => {
        window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
    }, [isFetchingHistories])

    // const compareTwoDates = (historyDate,envoieCurrentStatusDate)=>{
    //     var envoieCurrentStatusDateVar = new Date(envoieCurrentStatusDate);
    //     var historyDateVar = new Date(historyDate);
    //     return historyDateVar.getTime() >= envoieCurrentStatusDateVar.getTime();
    // }

    const getTypeClass = (typeCode) => {
        if (typeCode === 1) {
            return "nwe"
        } else if (typeCode === 2) {
            return "livre"
        } else if (typeCode === 3) {
            return "retour"
        } else {
            return "annule"
        }
    }

    console.log(histories)

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="envoie" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>
                        Tracking Envoie : {' '}
                        {
                            histories.length !== 0 && (
                                `${currentStatusEnvois.filter(item => item.id === histories[0].Envoi.currentStatus)[0]['nom']} - ${histories[0].Envoi ? histories[0].Envoi.tracking : histories[0].Envoi}`
                            )
                        }
                    </span>
                </div>

                {
                    histories.length !== 0 && (
                        <div className="supple-info">
                            <div className="bx">
                                <div className='ttl'>Expéditeur :</div>
                                <div>
                                    <span>Nom: </span>
                                    <span>{histories[0].Envoi.EntrepriseId ? histories[0].Envoi.Entreprise.nom : histories[0].Envoi.User.username}</span>
                                   </div>
                                <div>
                                    <span>Wilaya: </span>
                                    <span>{wilayas.filter(item => item.id === histories[0].Envoi.wilayaDeparture)[0] ? wilayas.filter(item => item.id === histories[0].Envoi.wilayaDeparture)[0]['nom'] : ""}</span>
                                </div>
                                {
                                    histories[0].Envoi.typeRamassage === 2 ? (
                                        <div>
                                            <span>Agence: </span>
                                            <span>{histories[0].Envoi.agenceDeparture && histories[0].Envoi.agenceDepartureAlias.nom}</span>
                                        </div>
                                    ) : (
                                        <div>
                                            <span>Adresse: </span>
                                            <span>{histories[0].Envoi.addressDeparture}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="bx">
                                <div className='ttl'>Destinataire :</div>
                                <div>
                                    <span>Nom: </span>
                                    <span>{histories[0].Envoi.nomArrived}</span>
                                </div>
                                <div>
                                    <span>Wilaya: </span>
                                    <span>{wilayas.filter(item => item.id === histories[0].Envoi.wilayaArrived)[0] ? wilayas.filter(item => item.id === histories[0].Envoi.wilayaArrived)[0]['nom'] : ""}</span>
                                </div>
                                {
                                    histories[0].Envoi.typeDelivery === 2 ? (
                                        <div>
                                            <span>Agence: </span>
                                            <span>{histories[0].Envoi.agenceArrived && histories[0].Envoi.agenceArrivedAlias.nom}</span>
                                        </div>
                                    ) : (
                                        <div>
                                            <span>Adresse: </span>
                                            <span>{histories[0].Envoi.addressArrived}</span>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
                }

                {
                    errorHistories ? <ErrorComponent error={errorHistories} /> : (
                        isFetchingHistories ? <LoadingComponent /> : (
                            histories.length === 0 ? <span className='no-data'>Il n'y a pas encore de tracking</span>
                                : (
                                    <div className="tracking-box">
                                        {
                                            histories.map((item, index) => (
                                                <div key={index} className="card" style={item.annuler == "1" ? { background: "#ff9494" } : {}}>
                                                    <span className={`tracking-title`}>Etat : {statusEnvois.filter(element => element.id === item.type)[0]['nom']}</span>
                                                    <span className={`tracking-current-status ${getTypeClass(item.currentStatus)}`}>
                                                        {currentStatusEnvois.filter(ele => ele.id === item.currentStatus)[0]['nom']}
                                                    </span>
                                                    {
                                                        item.Envoi.dead === 1 && (
                                                            <span className="material-symbols-rounded tracking-lock">lock</span>
                                                        )
                                                    }
                                                    {
                                                        item.type !== 10 ? (
                                                            item.type === 3 && item.Action.agenceArrivedActionAlias ? ( // Etat: Dispatch
                                                                <>
                                                                    <span>Agence Départ : {item.Action.agenceDepartureActionAlias.nom}</span>
                                                                    <span>Wilaya Départ : {wilayas.filter(element => element.id === item.Action.agenceDepartureActionAlias.wilaya)[0]['nom']}</span>
                                                                    <span>Commune Départ : {communes[item.Action.agenceDepartureActionAlias.wilaya].filter(element => element.id === item.Action.agenceDepartureActionAlias.commune)[0]['nom']}</span>

                                                                    <span style={{ marginTop: "20px" }}>Agence d'Arrivé : {item.Action.agenceArrivedActionAlias.nom}</span>
                                                                    <span>Wilaya d'Arrivé : {wilayas.filter(element => element.id === item.Action.agenceArrivedActionAlias.wilaya)[0]['nom']}</span>
                                                                    <span>Commune d'Arrivé : {communes[item.Action.agenceArrivedActionAlias.wilaya].filter(element => element.id === item.Action.agenceArrivedActionAlias.commune)[0]['nom']}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span>Agence : {item.Action.agenceDepartureActionAlias.nom}</span>
                                                                    <span>Wilaya : {wilayas.filter(element => element.id === item.Action.agenceDepartureActionAlias.wilaya)[0]['nom']}</span>
                                                                    <span>Commune : {communes[item.Action.agenceDepartureActionAlias.wilaya].filter(element => element.id === item.Action.agenceDepartureActionAlias.commune)[0]['nom']}</span>
                                                                </>
                                                            )
                                                        ) : (
                                                            <span>Wilaya : {wilayas.filter(element => element.id === item.Envoi.wilayaDeparture)[0]['nom']}</span>
                                                        )
                                                    }
                                                    {
                                                        ((item.type === 1) || (item.type === 5)) && (
                                                            <>
                                                                <span>Livreur : {item.Action.userActionDeliveryAlias.Userinfo.nom}</span>
                                                                <span>Tel : {item.Action.userActionDeliveryAlias.Userinfo.tel1}</span>
                                                                {
                                                                    (item.Casehistories.length !== 0) && (
                                                                        <div className="sortie-domicile">
                                                                            {
                                                                                item.Casehistories.map((casehistory, index) => (
                                                                                    <div key={index} className="mini-card">
                                                                                        <span className={(casehistory.type === 1 || casehistory.type === 4) ? 'on' : 'off'}>Statut : {historyCases.filter(element => element.id === casehistory.type)[0]['nom']}</span>
                                                                                        <span style={{ display: 'flex', gap: '5px' }}>
                                                                                            <p style={{ whiteSpace: 'nowrap' }}>Motif :</p>
                                                                                            <p>{casehistory.motif}</p></span>
                                                                                        <span>Date : {casehistory.createdAt.slice(0, 10)}  {casehistory.createdAt.slice(11, 19)}</span>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                    <div className='date'>
                                                        <span>{item.createdAt.slice(11, 19)}</span>
                                                        <span>{item.createdAt.slice(0, 10)}</span>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                        )
                    )
                }


            </div>
        </div>
    )
}
export default TrackingEnvoie